'use strict';

import PhotoService from './PhotoService';

export var service = new PhotoService();